import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { TS_Icons } from '@nu-art/ts-styles';
import { GenericDropDownV3, SimpleListAdapter, Button, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { NLPEnvOptions } from '@app/advisor-shared';
import { ModuleFE_Advisor_Tag } from '../../../modules/static-modules/healthcare-space.js';
const Props_AdvisorTags = {
    module: ModuleFE_Advisor_Tag,
    modules: [ModuleFE_Advisor_Tag],
    mapper: (item) => [item.label],
    placeholder: 'Choose a tag',
    renderer: (item) => _jsx("div", { className: 'node-data', children: item.label }),
    sortBy: [(item) => item.label]
};
export const DropdownAdvisorTag = (props) => _jsx(GenericDropDownV3, { ...Props_AdvisorTags, ...props });
const Props_Tags = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Advisor_Tag,
    itemRenderer: (item, onDelete) => {
        if (!item)
            return _jsx(_Fragment, { children: "Not Found" });
        return _jsxs(_Fragment, { children: [_jsx(Button, { onClick: onDelete, className: 'icon-clickable', children: _jsx(TS_Icons.x.component, {}) }), item.label] });
    },
    uiSelector: DropdownAdvisorTag
});
export const AdvisorTagMultiSelect = TS_MultiSelect_V2.prepare(Props_Tags);
const envAdapter = SimpleListAdapter(NLPEnvOptions, item => _jsx(_Fragment, { children: item.item }));
const EnvDropDown_Props = {
    adapter: envAdapter,
    placeholder: 'Select nlp env',
};
export const DropDown_NlpEnv = TS_DropDown.prepareEditable(EnvDropDown_Props);
//# sourceMappingURL=ui-components.js.map